<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import eventBus from './eventBus';

export default {
  name: 'App',
  created() {
    eventBus.$on('permission-denied', this.showPermissionDeniedToast);
  },
  beforeDestroy() {
    eventBus.$off('permission-denied', this.showPermissionDeniedToast);
  },
  methods: {
    showPermissionDeniedToast() {
      this.makeBootstrapToast('Permission Denied', 'You dont have permission to perform this action. Please contact your senior for further assistance.', 'danger');
    },
  },
};
</script>
